import { BrandColors } from '../theme';

export const cardTokens = {
    root: {
        background: BrandColors.surface[0],
        borderRadius: '12px',
        color: BrandColors.surface[700],
    },
    body: {
        padding: '1.25rem',
        gap: '0.75rem',
    },
};
